module.exports = __webpack_public_path__ + "img/fut.b6d7cc96.png";